import _ from 'lodash'
import moment from 'moment'
import { convert } from '../../helpers/units'
import { translateString } from '../../helpers/utils'

const INTEGER_REGEX = /^-?[1-9]\d*$/
const NUMBER_REGEX = /^-?\d*\.?\d*$/

export type SerializationOptions = {
  translationTable?: any
  inputAs?: string
  storedAs?: string
}

export const deserializeValue = (type, format, value, options: SerializationOptions = {}) => {
  if (_.isNil(value)) {
    return ''
  }

  const { translationTable, inputAs, storedAs } = options

  if (type === 'string') {
    if (format === 'date') {
      const date = moment(value)
      return date.isValid() ? date.format('l') : ''
    } else if (format === 'date-time') {
      const dateTime = moment(value)
      return dateTime.isValid() ? dateTime.format('MMM DD, YYYY h:mm A z') : ''
    } else {
      value = translateString(value, translationTable)
    }
  }

  if (inputAs && storedAs && _.isFinite(value)) {
    value = convert(value, storedAs, inputAs)
    value = normalizeNumeric(value, type)
  }

  return String(value)
}

export const serializeValue = (type, value, options: SerializationOptions = {}) => {
  const { inputAs, storedAs } = options

  if (_.isEmpty(value)) {
    value = undefined
  } else if (type === 'integer') {
    value = parseInt(value, 10)
    value = _.isNaN(value) ? undefined : value
  } else if (type === 'number') {
    value = parseFloat(value)
    value = _.isNaN(value) ? undefined : value
  }
  if (inputAs && storedAs && _.isFinite(value)) {
    value = convert(value, inputAs, storedAs)
    value = normalizeNumeric(value, type)
  }

  return value
}

/** Cleans up floating-point error artifacts, according to the data type */
export function normalizeNumeric(value: number, type?: string): number {
  if (type === 'integer') {
    return Math.round(value)
  }
  if (type === 'number') {
    // Rounds to 15 sig figs (the min precision doubles guarantee; 53-bit significand,
    // log_10(2^53)=15.95, so at least 15 sig figs), discarding noise that may be in the 16th+
    // digits. e.g. 0.30000000000000004 -> 0.3.
    return parseFloat(value.toPrecision(15))
  }
  return value
}

export const isValid = (type: string | undefined, value: string) => {
  if (_.isEmpty(value)) {
    return true
  } else if (type === 'integer') {
    return !!INTEGER_REGEX.exec(value)
  } else if (type === 'number') {
    return !!NUMBER_REGEX.exec(value)
  }
  return true
}
